import { useQuery } from '@tanstack/react-query';
import type {
  V3ApiSuccessData,
  V3ApiError,
} from 'javascripts/services/v3ApiClient';
import { request } from 'javascripts/services/v3ApiClient';
import { type PageObject } from 'data/v3/data-contracts';

export type GetProjectPagesResponse = V3ApiSuccessData<PageObject[]>;

export const PROJECT_PAGES_QUERY_KEY = 'ProjectPages';

export const useGetProjectPages = ({
  projectDbId,
}: {
  projectDbId: number;
}) => {
  const { data, isLoading, isError, refetch, isFetching, isRefetching } =
    useQuery<GetProjectPagesResponse, V3ApiError>({
      queryFn: async () => {
        const response = await request({
          url: `projects/${projectDbId}/pages`,
          params: {
            limit: 500,
          },
        });
        return response.data;
      },
      queryKey: [PROJECT_PAGES_QUERY_KEY, projectDbId],
    });

  const pages = data?.data || [];

  return {
    pages,
    refetch,
    isFetching,
    isRefetching,
    isLoading,
    isError,
  };
};
